import React, { Suspense } from "react";
import { renderRoutes } from "react-router-config";
import { 
  ProgressBar,
  Container,
} from "react-bootstrap";

import PropTypes from "prop-types";

const RedirectApp = (props) => {
  const { route } = props; 

  return (
    <div>
      <Container fluid>
        <Suspense fallback={<ProgressBar striped />}>
          {renderRoutes(route.routes)}
        </Suspense>
      </Container>
    </div>
  );
};

RedirectApp.propTypes = {
  route: PropTypes.object,
};

export default RedirectApp;
